import type { Lot } from '../../types/lot'

import { getActiveTenantKey, getTenantScopedKey } from '../tenant'
import { saveJSON } from '../../utils/storage'

const LOT_STORAGE_KEY = 'lots:v1'

type LotsPayloadV1 = {
  version: 1
  items: Lot[]
}

const hasStorage = (): boolean => typeof window !== 'undefined' && Boolean(window.localStorage)

const clone = <T>(value: T): T => structuredClone(value)

export const readLotsFromLocalStorage = (tenantKey = getActiveTenantKey()): Lot[] => {
  if (!hasStorage()) return []
  try {
    const scopedKey = getTenantScopedKey(LOT_STORAGE_KEY, tenantKey)
    const raw = window.localStorage.getItem(scopedKey)
      ?? (tenantKey === 'default' ? window.localStorage.getItem(LOT_STORAGE_KEY) : null)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return []
    const payload = parsed as Partial<LotsPayloadV1>
    if (payload.version !== 1 || !Array.isArray(payload.items)) return []
    return clone(payload.items)
  } catch {
    return []
  }
}

export const writeLotsToLocalStorage = (lots: Lot[], tenantKey = getActiveTenantKey()): void => {
  if (!hasStorage()) return
  const payload: LotsPayloadV1 = { version: 1, items: clone(lots) }
  const scopedKey = getTenantScopedKey(LOT_STORAGE_KEY, tenantKey)
  saveJSON(scopedKey, payload)
}
